import { get } from 'framework/api/http';
import { useQuery } from 'react-query';

/* Get user dashboard data */
export const getAllTicketsStats = async () => {
  const res = await get(`/enterprise-tickets-api/get_all_tickets`);
  return res?.data || [];
};

/* Use Query as a Hook */
export const useGetAllTickets = (onSuccess: any, onError: any) => {
  return useQuery('all-tickets-stats', getAllTicketsStats, {
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    onSuccess,
    onError,
  });
};

export default useGetAllTickets;
